<template>
    <svg
        width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        v-on="$listeners"
    >
        <path
            d="M18.132 13.717A4.518 4.518 0 0 0 16.56 11.8c.89-.8 1.44-2 1.44-3.3 0-2.32-1.75-4.22-4-4.47V2h-2v2h-2V2H8v1.586L10.414 6H13.5a2.5 2.5 0 0 1 1.45 4.536l3.182 3.181z"
            fill="currentColor"
        ></path>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.06 1.94L2.94 4.06 8 9.122V18H6.5L6 20h2v2h2v-2h2v2h2v-2c1.347 0 2.549-.58 3.371-1.508l2.568 2.569 1.354-1.354-17-17 .768-.768zm10.887 15.128L11.879 13h-1.88v5h4a2.5 2.5 0 0 0 1.948-.932z"
            fill="currentColor"
        ></path>
    </svg>
</template>

<script>
export default {
    name: "BillableIcon"
};
</script>
